module.exports = __webpack_public_path__ + "img/p2-bottom-bg.81ba48f0.png";